import type { UserIDProps } from '@yandex-lego/user';
import { User } from '@yandex-lego/user';
import cn from 'classnames';
import { UserBarItem, useStack } from '@direct-frontend/components';
import { useYandexIdUserBarItem } from './lib/hooks/useYandexIdUserBarItem';
import { withDeferred } from '../../lib/hocs';
import styles from './YandexIdUserBarItem.module.css';

function UserPlaceholder({ avatarSize }: UserIDProps) {
    const size = typeof avatarSize === 'number' ? avatarSize : 28;

    return <div style={{ width: size, height: size, borderRadius: '50%' }} />;
}

const DeferredUser = withDeferred(User, UserPlaceholder);

export type YandexIdUserBarItemProps = {
    platform: 'desktop' | 'touch';
    dialogClassName?: string;
};

export function YandexIdUserBarItem({ platform, dialogClassName }: YandexIdUserBarItemProps) {
    const userBarItemClassName = useStack({ justifyContent: 'center' });
    const yandexIdProps = useYandexIdUserBarItem({
        platform,
        dialogClassName,
    });

    return (
        <UserBarItem as="div" className={cn(userBarItemClassName, styles.root)}>
            <DeferredUser {...yandexIdProps} />
        </UserBarItem>
    );
}
